<template>
  <div v-if="list.length > 0">
    <div class="clockin-items">
      <div class="clockin-item" v-for="(item, index) in list" :key="index">
        <div class="clockin-left">
          <img class="clockin-cover" :src="item.cover_img" />
          <div class="clockin-cover_modal" v-if="item.status == 2">
            本次打卡活动已结束
          </div>
        </div>
        <div class="clockin-right">
          <div class="clockin-title">{{ item.title }}</div>
          <div class="clockin-time">
            活动时间：{{ item.start_time | tsFormatLong }} -
            {{ item.end_time | tsFormatLong }}
          </div>
          <div class="clockin-price">
            <span>活动价格：</span>
            <span v-if="item.price == 0">免费</span>
            <CurrencyNew v-else :price="item.price"></CurrencyNew>
          </div>
          <div class="clockin-bottom">
            <span class="clockin-reward">奖金：{{ item.reward / 100 }}元</span>
          </div>
        </div>
      </div>
    </div>
    <div class="clockin-tip">
      <div class="clockin-tip_text">
        温馨提示：参加打卡活动或提现奖金请至移动端
      </div>
      <div>我的奖金累计：</div>
      <CurrencyNew :price="reward" :showFreeText="false"></CurrencyNew>
    </div>
  </div>
  <div class="clockin-empty" v-else>
    <EmptyNew title="暂无打卡记录"></EmptyNew>
  </div>
</template>
<script>
import EmptyNew from "@/components/EmptyNew";
import { triggerLoaded } from "@/components/LoadContainer.vue";

export default {
  name: "MemberClockin",
  components: { EmptyNew },
  data() {
    return {
      list: [],
      reward: 0,
    };
  },
  computed: {
    svg() {
      return this.$store.state.svg || "¥";
    },
  },
  async created() {
    let data = await this.$http.get("/api/app/clockIn/myTake/detail");
    this.list = data.data;
    this.reward = data.reward;
    triggerLoaded(this);
  },
};
</script>
<style lang="scss" scoped>
.clockin-items {
  background: white;
  border-radius: 10px;
}
.clockin-item {
  padding: 24px 0 23px 0;
  display: flex;
  border-bottom: 1px solid #e6e6e6;
  margin: 0 24px;

  &:last-child {
    border-bottom: none;
  }
}
.clockin-left {
  width: 156px;
  height: 104px;
  border-radius: 4px;
  margin-right: 16px;
  position: relative;
}
.clockin-cover {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  display: block;
}
.clockin-cover_modal {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  text-align: center;
  font-size: 12px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 7px;
  background: rgba($color: #000000, $alpha: 0.1);
  box-sizing: border-box;
}
.clockin-right {
  flex: 1;
}
.clockin-title {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
  height: 44px;
  overflow: hidden;
  margin-bottom: 16px;
}
.clockin-time {
  font-size: 14px;
  color: #999999;
  margin-bottom: 4px;
}
.clockin-price {
  font-size: 14px;
  color: #999999;
  display: flex;

  /deep/ {
    .price {
      font-size: 14px;
      align-items: center;
    }
  }
}
.clockin-bottom {
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
}
.clockin-reward {
  width: 130px;
  height: 32px;
  opacity: 1;
  border: 1px solid #ef811e;
  border-radius: 17px;
  box-sizing: border-box;
  text-align: center;
  line-height: 30px;
  color: #ef811e;
}
.clockin-tip {
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 9;
  top: 10px;
  right: 25px;

  /deep/ {
    .price,
    .price .rmb-svg-new {
      font-size: 18px !important;
      align-items: center;
    }
  }
}
.clockin-tip_text {
  height: 28px;
  background: rgba($color: #ef811e, $alpha: 0.08);
  color: #ef811e;
  line-height: 28px;
  border-radius: 4px;
  position: relative;
  padding: 0 12px;
  margin-right: 13px;

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-left-color: rgba($color: #ef811e, $alpha: 0.08);
    top: 50%;
    transform: translateY(-50%);
    right: -10px;
  }
}
.clockin-empty {
  background: white;
}
</style>
